/*
    Our page settings:

    1. name of the dottie meta element
*/

const metaId = '_dottie';

/*
    2. number of results per page
*/
const limit = 12;

/*
    3. map access token, id and general options
*/
const dottieAppDom = document.querySelector('.js-dottie-app');
export const mapBoxAccessToken = dottieAppDom ? dottieAppDom.getAttribute('data-map-box-token') : '';

const map = {
    accessToken: mapBoxAccessToken,
    options: {
        maxZoom: 18,
        minZoom: 4,
        zoom: 14,
        attributionControl: false,
        center: [41.88262125504959, -87.62371964253434],
        // eslint-disable-next-line
        dragging: !L.Browser.mobile,
        // eslint-disable-next-line
        tap: !L.Browser.mobile,
    },
    showMap: true,
    mapId: 'tzo-dottie-map',
};

function setDefaultMapBounds() {

    try {

        const elm = document.getElementById(metaId);
        if (!elm) return;

        const json = elm.getAttribute('content');
        if (!json) return;

        const parsed = JSON.parse(json);
        if (parsed.mapMaxBounds
            && Array.isArray(parsed.mapMaxBounds)
            && parsed.mapMaxBounds.length === 2
            && Array.isArray(parsed.mapMaxBounds[0])
            && Array.isArray(parsed.mapMaxBounds[1])
        ) {

            map.options.maxBounds = parsed.mapMaxBounds;

        } else if (parsed.mapMaxBounds) {

            /** eslint-disable no-console */
            console.warn('Invalid mapMaxBounds format:', parsed.mapMaxBounds);

        }

    } catch (error) {

        /** eslint-disable no-console */
        console.error('Error setting maxBounds:', error);

    }

}

setDefaultMapBounds();

/*
    4. listing image width and height
*/
const imageWidth = 340;
const imageHeight = 212;

export const config = {
    metaId,
    limit,
    map,
    imageWidth,
    imageHeight,
};
